import React from 'react';
import { useStyletron } from 'styletron-react';

import { wrapperStyles } from './styles';

interface Props {
  children: React.ReactNode;
  center?: boolean;
  style?: React.CSSProperties;
}

export function Wrapper({ children, center, style }: Props) {
  const [css] = useStyletron();
  return (
    <div
      className={css(wrapperStyles({ center }))}
      style={style}
    >
      {children}
    </div>
  );
}
